import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=01e91800&scoped=true&"
import script from "./FileDownload.vue?vue&type=script&lang=js&"
export * from "./FileDownload.vue?vue&type=script&lang=js&"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=01e91800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e91800",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
